import React from "react";
import { useProfile } from "@/hooks/firestore/user/useProfile";
import { PageMessage } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { ReactComponent as RestrictedIcon } from "assets/illustrations/warning-map.svg";

type RegionRestrictedProps = {
  children: React.ReactNode;
};

const RegionRestricted = ({ children }: RegionRestrictedProps) => {
  const { profile, isLoading: profileLoading } = useProfile();

  const isRegionRestricted = profileLoading
    ? false
    : profile?.userVerificationStatus === "NOT_REQUIRED";

  if (isRegionRestricted) {
    return (
      <PageMessage
        title="Verification not required"
        image={<RestrictedIcon />}
        subTitle="Verification is only required for Users in regions we offer Betting."
      >
        <SupportLink
          hideChevron
          options={{ labels: ["weblink-country-restrictions"] }}
          type={`button`}
        >
          Learn More
        </SupportLink>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { RegionRestricted };
